export const capitalize = (value: string): string => value.toLowerCase().replace(/^./, (char) => char.toUpperCase())
